<!-- ══════════════════════════════════════════════════════════════════════════
     INTELIGENCIA ARTIFICIAL — la configuración de la IA del núcleo.
     Contrato: kredit-api-MT/modules/ia/CONTRATO.md §8.2.

     Encabezado, cinta y solapas fijos; lo de abajo es el <router-outlet>. Es el
     mismo gesto que la ficha del comercio (Juan, 2026-09-20: «cámbiame la
     información que está abajo»). Y el mismo ámbito `kb-gateway`: botones en
     negro, como el Integration Gateway, porque la solapa «Asistente de IA» de la
     ficha del comercio vive dentro de ese ámbito y las dos pantallas se tocan.
     ══════════════════════════════════════════════════════════════════════════ -->
<div class="kb-page kb-gateway">

  <div class="kb-page-header">
    <div>
      <h1 class="kb-page-title flex items-center gap-2 !font-bold">
        <i class="fas fa-robot text-[0.85em] text-muted-foreground" aria-hidden="true"></i>Inteligencia artificial
      </h1>
      <p class="kb-page-meta">
        Las claves, los modelos, el gasto y qué comercios tienen el asistente prendido.
      </p>
    </div>
  </div>

  <!-- Quien no configura: una línea, y adentro no se le ofrece ninguna acción que no tiene. -->
  <p class="m-0 flex items-center gap-2 text-sm text-muted-foreground" *ngIf="soloLectura" role="status">
    <i class="fas fa-eye" aria-hidden="true"></i>Estás viendo en modo de sólo lectura.
  </p>

  <!-- La única cinta: la IA apagada cambia el sentido de todo lo de abajo. -->
  <div class="kb-cinta" *ngIf="apagada && !enEstado" role="status">
    <i class="fas fa-power-off kb-cinta-icono" aria-hidden="true"></i>
    <p class="m-0">
      <span class="font-semibold">La IA está apagada: ningún agente contesta.</span>
      <ng-container *ngIf="estado?.apagado?.causa"> {{ nombreCausa(estado?.apagado?.causa) }}.</ng-container>
      <ng-container *ngIf="estado?.apagado?.motivo"> «{{ estado?.apagado?.motivo }}».</ng-container>
      <ng-container *ngIf="estado?.apagado?.por"> La apagó {{ estado?.apagado?.por }}</ng-container><ng-container
        *ngIf="estado?.apagado?.desde">, {{ haceCuanto(estado?.apagado?.desde) }}</ng-container><ng-container
        *ngIf="estado?.apagado?.por || estado?.apagado?.desde">.</ng-container>
      Prender un comercio no hace que el botón aparezca en su portal hasta que la vuelvas a prender.
    </p>
  </div>

  <div class="overflow-x-auto">
    <nav class="kb-tabs-list" aria-label="Secciones de inteligencia artificial">
      <a class="kb-pestana" [routerLink]="['/console/ia']"
         routerLinkActive="kb-pestana-activa" [routerLinkActiveOptions]="{ exact: true }">Estado</a>
      <a class="kb-pestana" [routerLink]="['/console/ia', 'agentes']" routerLinkActive="kb-pestana-activa">Agentes</a>
      <a class="kb-pestana" [routerLink]="['/console/ia', 'comercios']" routerLinkActive="kb-pestana-activa">Comercios</a>
      <a class="kb-pestana" [routerLink]="['/console/ia', 'bitacora']" routerLinkActive="kb-pestana-activa">Bitácora</a>
      <a class="kb-pestana" [routerLink]="['/console/ia', 'probar']" routerLinkActive="kb-pestana-activa">Probar</a>
    </nav>
  </div>

  <router-outlet></router-outlet>
</div>
